import React from "react";
import { General } from "../data/General";

const Navbar: React.FC = () => {
  const menuItems = ["Work", "Services", "About",  "Contact"];

  return (
    <nav className="fixed top-0 z-50 w-full border-b bg-slate-900/80 backdrop-blur-sm border-slate-700">
      <div className="flex items-center justify-between max-w-6xl px-6 py-4 mx-auto">
        <div className="text-xl font-bold text-transparent bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text">
          {General.name}
        </div>
        <div className="hidden gap-8 md:flex">
          {menuItems.map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="transition-colors text-slate-300 hover:text-white"
            >
              {item}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
